import { Typography } from "@mui/material";
import styles from "../css/GadgetCountLabel.module.css";
import { capitalizeFirstLetter } from "../../../../helper/utils";

interface GadgetCountLabelProps {
    platform: string;
    count: number
}

export const GadgetCountLabel = ({platform, count}: GadgetCountLabelProps) => (
    <Typography variant="h2" className={styles.platfromText}>{`${count} agents for `}<span>{capitalizeFirstLetter(platform)}</span></Typography>
);